import {FC, memo} from 'react';
import {Box} from '@chakra-ui/react';
import {useShallow} from 'zustand/react/shallow';
import {useMessagesStore} from 'stores';
import {EllipseButton} from 'ui-kit';

interface IProps {
  onScrollClick: () => void;
}

const ScrollButtonFC: FC<IProps> = ({onScrollClick}) => {
  const {filter} = useMessagesStore(useShallow((state) => state));

  return (
    <Box position={'absolute'} bottom={filter ? '200px' : '150px'} left={'calc(50% - 16px)'}>
      <EllipseButton
        isRounded
        size={'normal'}
        iconSize={'s32'}
        variant={'whiteTransparent'}
        icon={'ArrowDown'}
        onClick={onScrollClick}
      />
    </Box>
  );
};

export const ScrollButton = memo(ScrollButtonFC);
